import Vue from 'vue';
import Form from './form';
import Item from './item';
import DataBox from './dynamic-data-box'
Vue.component('dynamic-data-box', DataBox);
Vue.component('dynamic-form', Form);
Vue.component('dynamic-form-item', Item);

